import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, DoCheck, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import FileSaver from 'file-saver';
import { DisruptedOrder, DisruptedOrderViewerScreen, FlightSegment, RequestBody } from 'src/app/model/screen/disrupted-order-viewer-screen';
import { YourBookingScreen } from 'src/app/model/screen/your-booking-screen';
import { DateFormatPipe } from 'src/app/pipe/date-format.pipe';
import { ApiService, Response } from 'src/app/service/api.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import xmlFormat from 'xml-formatter';

@Component({
  selector: 'app-disrupted-order-viewer-screen',
  templateUrl: './disrupted-order-viewer-screen.component.html',
  styleUrls: ['./disrupted-order-viewer-screen.component.scss']
})
export class DisruptedOrderViewerScreenComponent implements OnInit, DoCheck {
  disruptedOrderViewer: DisruptedOrderViewerScreen = {} as DisruptedOrderViewerScreen;
  changeDateAndTime: YourBookingScreen = {} as YourBookingScreen;

  FlightSegment: FlightSegment[] = [];
  pnr: any;
  iataNumber: any;
  ocnMessageScreen: any = {
    iataNumber: '',
    aggregatorID: '',
    overAllPendingPnrDetails: [],
    overAllActionedPnrDetails: [],
    overAllArchivePnrDetails: [],
    pendingPnrDetails: [],
    actionedPnrDetails: [],
    archivePnrDetails: [],
    sortArchivePnrDetails: [],
    sortPendingPnrDetails: [],
    sortActionedPnrDetails: []
  };
  orderDetails: DisruptedOrder[] = [];
  aggrId = '';
  iataNum = '';

  actioned = false;
  pending = true;
  archive = false;
  loggeduserMailID: any;

  reqBody: RequestBody[] = [];

  ocnMessageError = '';
  apiResponse: Response = {} as Response;
  changeDateAndTimeBookingData: DisruptedOrderViewerScreen = {} as DisruptedOrderViewerScreen;

  searchForm: FormGroup<any> = this.initSearchForm();

  //pagination for pending tab
  pendingOcnMessagePaginationSettings: any = {
    beforeActiveMenuButtonCount: 1,
    afterActiveMenuButtonCount: 1,
    buttonList: [],
    activePageIndex: 0,
    maxPageIndex: 0,
    start: 0,
    activeLength: 10,
    lengthMenu: [
      { Label: '10', Value: 10 },
      { Label: '20', Value: 20 },
      { Label: '30', Value: 30 },
      { Label: '40', Value: 40 }
    ]
  };
  //end
  //pagination for acrion tab
  actionedOcnMessagePaginationSettings: any = {
    beforeActiveMenuButtonCount: 1,
    afterActiveMenuButtonCount: 1,
    buttonList: [],
    activePageIndex: 0,
    maxPageIndex: 0,
    start: 0,
    activeLength: 10,
    lengthMenu: [
      { Label: '10', Value: 10 },
      { Label: '20', Value: 20 },
      { Label: '30', Value: 30 },
      { Label: '40', Value: 40 }
    ]
  };
  //end
  //pagination for archive tab
  archiveOcnMessagePaginationSettings: any = {
    beforeActiveMenuButtonCount: 1,
    afterActiveMenuButtonCount: 1,
    buttonList: [],
    activePageIndex: 0,
    maxPageIndex: 0,
    start: 0,
    activeLength: 10,
    lengthMenu: [
      { Label: '10', Value: 10 },
      { Label: '20', Value: 20 },
      { Label: '30', Value: 30 },
      { Label: '40', Value: 40 }
    ]
  };
  masterSelected: boolean = false;
  //end
  isEnableSearch: boolean = false;
  minToDate: any;
  maxToDate: any;

  constructor(
    private formBuilder: FormBuilder,
    private sandboxPageStateService: SandboxPageStateService,
    public apiService: ApiService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private datePipe: DateFormatPipe
  ) {}
  ngOnInit() {
    // this.getOcnMessages('PENDING');

    this.loggeduserMailID = this.sandboxPageStateService.getEncodedUserEmail();
    this.sandboxPageStateService.castResfreshObs.subscribe((res: any) => {
      if (res) {
        this.searchPNR();
      }
    });
  }

  ngDoCheck(): void {
    let pnr = this.search_form_inp_group_val('pnr');
    let fromDate = this.search_form_inp_group_val('fromDate');
    let toDate = this.search_form_inp_group_val('toDate');
    if (fromDate) {
      const fromDateObj = new Date(fromDate);
      const toDateObj = new Date(toDate);
      const maxToDate = new Date(fromDateObj);
      maxToDate.setDate(fromDateObj.getDate() + 7);

      this.minToDate = fromDate;
      this.maxToDate = maxToDate.toISOString().split('T')[0];
      if (toDateObj > maxToDate || fromDateObj > toDateObj) {
        this.searchForm.get('toDate')?.setValue(this.maxToDate);
      }
    }
    this.isEnableSearch = (pnr !== '' && this.searchForm.controls['pnr'].valid) || (fromDate !== '' && toDate !== '') ? true : false;
  }

  disruptScreenCloseClick() {
    let patchSandboxSourceData = { hideSideMenu: 'Yes', mainMenu: 'none' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
  initSearchForm() {
    return this.formBuilder.group({
      pnr: ['', [Validators.maxLength(6), Validators.minLength(6)]],
      fromDate: [''],
      toDate: ['']
    });
  }
  search_form_inp_group(controlName: any) {
    return this.searchForm.controls[controlName];
  }
  search_form_inp_group_val(controlName: any) {
    return this.search_form_inp_group(controlName).value;
  }
  refreshList() {
    this.ocnMessageScreen.pendingPnrDetails = [];
    this.ocnMessageScreen.sortPendingPnrDetails = [];
    this.ocnMessageScreen.archivePnrDetails = [];
    this.ocnMessageScreen.sortArchivePnrDetails = [];
    this.ocnMessageScreen.actionedPnrDetails = [];
    this.ocnMessageScreen.sortActionedPnrDetails = [];
    this.ocnMessageScreen.overAllPendingPnrDetails = [];
    this.ocnMessageScreen.overAllActionedPnrDetails = [];
    this.ocnMessageScreen.overAllArchivePnrDetails = [];
    this.reqBody = [];
    this.masterSelected = false;
    this.resetForm();
    if (this.pending) {
      //pagination for pending tab
      this.pendingOcnMessagePaginationSettings.activePageIndex = 0;
      this.pendingOcnMessagePaginationSettings.activeLength = 10;
      //end
    }
    if (this.actioned) {
      //pagination for action tab
      this.actionedOcnMessagePaginationSettings.activePageIndex = 0;
      this.actionedOcnMessagePaginationSettings.activeLength = 10;
      //end
    }
    if (this.archive) {
      //pagination reset for archive tab
      this.archiveOcnMessagePaginationSettings.activePageIndex = 0;
      this.archiveOcnMessagePaginationSettings.activeLength = 10;
      //end
    }
    let status: 'PENDING' | 'ACTIONED' | 'ARCHIVE' = 'PENDING';
    if (this.pending) {
      status = 'PENDING';
    } else if (this.actioned) {
      status = 'ACTIONED';
    } else if (this.archive) {
      status = 'ARCHIVE';
    }
    // this.getOcnMessages(status);
  }

  loadAmendentsFlightRefs(amendentsFlightLists: any) {
    let flightRefs: any = [];
    if (amendentsFlightLists && amendentsFlightLists.length) {
      amendentsFlightLists.forEach((amendentsFlight: any) => {
        flightRefs.push(amendentsFlight.REMARKS[0].$.REFS);
      });
    }
    return flightRefs;
  }
  loadAmendentsFlightActions(amendentsFlightLists: any) {
    let flightActionType: any = [];
    if (amendentsFlightLists && amendentsFlightLists.length) {
      amendentsFlightLists.forEach((amendentsFlight: any) => {
        flightActionType.push(amendentsFlight.ACTIONTYPE[0]._);
      });
    }

    return flightActionType;
  }

  convertDate(date: string, type: string): string {
    const [year, month, day] = date.split('-');
    if (type === 'from') {
      return `${year}${month}${day}-000000`;
    }
    return `${year}${month}${day}-235959`;
  }

  async getOcnMessages(status: 'PENDING' | 'ACTIONED' | 'ARCHIVE') {
    const apiConnectionProfile = this.sandboxPageStateService.getActiveAPIConnectionProfile();
    let fromDate = this.convertDate(this.search_form_inp_group_val('fromDate').trim(), 'from');
    let toDate = this.convertDate(this.search_form_inp_group_val('toDate').trim(), 'to');
    let pnr = this.search_form_inp_group_val('pnr').trim();
    this.aggrId = apiConnectionProfile.aggregatorID;
    this.iataNum = apiConnectionProfile.iata;
    this.ocnMessageScreen.iataNumber = this.iataNum;
    this.ocnMessageScreen.aggregatorID = this.aggrId;
    let queryParams = new HttpParams();
    queryParams = queryParams.append('aggregator_id', this.aggrId);
    queryParams = queryParams.append('iata_number', this.iataNum);
    let aStatus = status === 'ARCHIVE' ? 'ARCHIVED' : status;
    queryParams = queryParams.append('status', aStatus);
    if (fromDate !== '' && toDate !== '' && pnr === '') {
      queryParams = queryParams.append('fromDate', fromDate);
      queryParams = queryParams.append('toDate', toDate);
    }
    if (pnr !== null && pnr !== '') {
      queryParams = queryParams.append('pnr', pnr.toUpperCase());
    }

    this.ocnMessageError = '';
    this.apiResponse = await this.apiService.sendGetRequest('/read-ocn-messages', queryParams);
    if (this.apiResponse.success) {
      this.ocnMessageError = '';
      this.mapOcnViewerScreenData(this.apiResponse.success, status);
    } else if (this.apiResponse.error) {
      this.ocnMessageError = ' ';
      const status: number = this.apiResponse.error.status;

      switch (status) {
        case 401:
          window.location.reload();
          break;

        case 404:
          this.ocnMessageError = "No Records Found: selected profile doesn't contain any records.";
          break;

        case 500:
          this.ocnMessageError = '500 Internal Server Error';
          break;

        case 502:
          this.ocnMessageError = '502 Internal Server Error';
          break;

        case 503:
          this.ocnMessageError = '503 Service Unavailable';
          break;
        case 504:
          this.ocnMessageError = '504 Gateway Timeout Error';
          break;

        default:
          this.ocnMessageError = this.apiResponse.error.status + ' ' + this.apiResponse.error.error.errorDescription;
      }
    }
  }

  sortByCreatedDateTime(ocnMessageData: any) {
    return ocnMessageData.sort((a: any, b: any) => {
      return <any>new Date(this.convertDateTime(b.changedAt)) - <any>new Date(this.convertDateTime(a.changedAt));
    });
  }
  convertDateTime(currentTimestamp: string) {
    let date = currentTimestamp.split('-')[0];
    let formattedDate = date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8);
    let time = currentTimestamp.split('-')[1];
    let formattedTime = time.substring(0, 2) + ':' + time.substring(2, 4) + ':' + time.substring(4, 6);
    return formattedDate + ' ' + formattedTime;
  }

  mapOcnViewerScreenData(ocnMsg: any, status: 'PENDING' | 'ACTIONED' | 'ARCHIVE') {
    let distruptedPnrCount: any = 0;
    let pendingPnrDetails: any = [];
    let actionedPnrDetails: any = [];
    let archivePnrDetails: any = [];
    let ocnMessageData: any = ocnMsg;

    ocnMessageData = this.sortByCreatedDateTime(ocnMessageData);
    ocnMessageData.forEach((ocnMessageDetail: any, i: number) => {
      let updatedAT = this.convertDateTime(ocnMessageDetail.changedAt);
      if (ocnMessageDetail.status === 'PENDING') {
        distruptedPnrCount++;
      }
      let jsonDATA = this.xmlToJsonParserService.parseXMLToJSON(ocnMessageDetail.xml);
      let soapENV: any = {};
      let soapBody: any = {};

      let pnrXMl = ocnMessageDetail.xml;

      let userAction = ocnMessageDetail.userAction;
      let timeStamp = ocnMessageDetail.currentTimestamp;

      if (typeof jsonDATA['SOAP:ENVELOPE'] !== 'undefined') {
        soapENV = jsonDATA['SOAP:ENVELOPE'];
        soapBody = soapENV['SOAP:BODY'][0];
      } else if (typeof jsonDATA['SOAPENV:ENVELOPE'] !== 'undefined') {
        soapENV = jsonDATA['SOAPENV:ENVELOPE'];
        soapBody = soapENV['SOAPENV:BODY'][0];
      }

      let ORDERCHANGENOTIF: any = {};
      if (typeof soapBody['SENDMESSAGEREQUEST'] !== 'undefined') {
        let SENDMESSAGEREQUEST = soapBody['SENDMESSAGEREQUEST'][0];
        let PAYLOAD = SENDMESSAGEREQUEST['PAYLOAD'][0];
        ORDERCHANGENOTIF = PAYLOAD['ORDERCHANGENOTIF'][0];
      } else if (typeof jsonDATA['ORDERCHANGENOTIF'] !== 'undefined') {
        ORDERCHANGENOTIF = jsonDATA['ORDERCHANGENOTIF'];
      } else if (typeof soapBody['ORDERCHANGENOTIF'] !== 'undefined') {
        ORDERCHANGENOTIF = soapBody['ORDERCHANGENOTIF'][0];
      }
      let DATALISTS = ORDERCHANGENOTIF['DATALISTS'][0];
      let QUERY = ORDERCHANGENOTIF['QUERY'][0];
      let AMENDMENTS = QUERY['AMENDMENTS'][0];
      let AMENDMENTSFlightRefs = this.loadAmendentsFlightRefs(AMENDMENTS.AMENDMENT);
      let amendmentActionList = this.loadAmendentsFlightActions(AMENDMENTS.AMENDMENT);
      let FLIGHTSEGMENTLIST = DATALISTS['FLIGHTSEGMENTLIST'][0];
      let FLIGHTSEGMENTs = FLIGHTSEGMENTLIST['FLIGHTSEGMENT'];
      let FLIGHTSEGMENTLength = FLIGHTSEGMENTs.length;
      let AMENDMENTSFlightRefLength = AMENDMENTSFlightRefs.length;
      let pnrDetail: any = {};
      let noChangeFlightSegment: any = {};
      pnrDetail.pnr = ocnMessageDetail.pnr;
      pnrDetail.current_timestamp = ocnMessageDetail.currentTimestamp;
      pnrDetail.status = ocnMessageDetail.status;
      pnrDetail.iataNumber = ocnMessageDetail.iataNumber;
      pnrDetail.actionTypes = amendmentActionList;
      pnrDetail.FlightSegmentList = {};
      pnrDetail.cancelledFlightSegment = [];
      pnrDetail.scheduledFlightSegment = [];
      pnrDetail.FlightSegmentList = [];
      pnrDetail.xml = pnrXMl;
      pnrDetail.userAction = userAction;
      pnrDetail.isSelected = false;
      pnrDetail.current_timestamp = timeStamp;

      if (AMENDMENTSFlightRefLength > 0) {
        AMENDMENTSFlightRefs.forEach((ref: string) => {
          let refArray = ref.split(' ');
          refArray.forEach((reference: string) => {
            if (FLIGHTSEGMENTLength > 0) {
              FLIGHTSEGMENTs.forEach((FLIGHTSEGMENT: any) => {
                let segmentKey = FLIGHTSEGMENT.$.SEGMENTKEY;
                if (reference === segmentKey) {
                  let DEPARTUREDetails = FLIGHTSEGMENT['DEPARTURE'][0];
                  let ArrivalDetails = FLIGHTSEGMENT['ARRIVAL'][0];
                  let marketingCareerDetails = FLIGHTSEGMENT['MARKETINGCARRIER'] ? FLIGHTSEGMENT['MARKETINGCARRIER'][0] : null;
                  let operatingCareerDetails = FLIGHTSEGMENT['OPERATINGCARRIER'] ? FLIGHTSEGMENT['OPERATINGCARRIER'][0] : null;
                  let classServiceDetails = FLIGHTSEGMENT['CLASSOFSERVICE'] ? FLIGHTSEGMENT['CLASSOFSERVICE'][0] : null;
                  let flightDetails = FLIGHTSEGMENT['FLIGHTDETAIL'] ? FLIGHTSEGMENT['FLIGHTDETAIL'][0] : null;
                  let FlightSegmentListDetail: any = {};

                  FlightSegmentListDetail.flightChange = true;
                  FlightSegmentListDetail.Departure = {
                    AirportCode: DEPARTUREDetails.AIRPORTCODE[0],
                    Date: DEPARTUREDetails.DATE[0],
                    Time: DEPARTUREDetails.TIME[0],
                    AirportName: DEPARTUREDetails.AIRPORTNAME[0]
                  };
                  FlightSegmentListDetail.Arrival = {
                    AirportCode: ArrivalDetails.AIRPORTCODE[0],
                    Date: ArrivalDetails.DATE[0],
                    Time: ArrivalDetails.TIME[0],
                    AirportName: ArrivalDetails.AIRPORTNAME[0]
                  };
                  if (marketingCareerDetails !== null) {
                    FlightSegmentListDetail.MarketingCarrier = {
                      AirlineID: marketingCareerDetails.AIRLINEID[0],
                      FlightNumber: marketingCareerDetails.FLIGHTNUMBER[0]
                    };
                  }
                  if (operatingCareerDetails !== null) {
                    FlightSegmentListDetail.OperatingCarrier = {
                      Name: operatingCareerDetails.NAME[0]
                    };
                  }
                  if (classServiceDetails !== null) {
                    FlightSegmentListDetail.ClassOfService = {
                      Code: classServiceDetails.CODE[0],
                      MarketingName: classServiceDetails.MARKETINGNAME[0]
                    };
                  }
                  if (flightDetails !== null) {
                    FlightSegmentListDetail.FlightDetail = {
                      FlightSegmentType: flightDetails.FLIGHTSEGMENTTYPE[0]
                    };
                    if (flightDetails.FLIGHTSEGMENTTYPE[0] === 'UN') {
                      pnrDetail.UNDate = DEPARTUREDetails.DATE[0];
                      pnrDetail.cancelledFlightSegment.push(FlightSegmentListDetail);
                    } else {
                      pnrDetail.scheduledFlightSegment.push(FlightSegmentListDetail);
                    }
                  }
                }
              });
            }
          });
        });
      } else {
        FLIGHTSEGMENTs.forEach((FLIGHTSEGMENT: any) => {
          let DEPARTUREDetails = FLIGHTSEGMENT['DEPARTURE'][0];
          let ArrivalDetails = FLIGHTSEGMENT['ARRIVAL'][0];
          let marketingCareerDetails = FLIGHTSEGMENT['MARKETINGCARRIER'][0];
          let operatingCareerDetails = FLIGHTSEGMENT['OPERATINGCARRIER'][0];
          let classServiceDetails = FLIGHTSEGMENT['CLASSOFSERVICE'][0];
          let flightDetails = FLIGHTSEGMENT['FLIGHTDETAIL'][0];
          let FlightSegmentListDetail: any = {};

          FlightSegmentListDetail.flightChange = true;
          FlightSegmentListDetail.Departure = {
            AirportCode: DEPARTUREDetails.AIRPORTCODE[0],
            Date: DEPARTUREDetails.DATE[0],
            Time: DEPARTUREDetails.TIME[0],
            AirportName: DEPARTUREDetails.AIRPORTNAME[0]
          };
          FlightSegmentListDetail.Arrival = {
            AirportCode: ArrivalDetails.AIRPORTCODE[0],
            Date: ArrivalDetails.DATE[0],
            Time: ArrivalDetails.TIME[0],
            AirportName: ArrivalDetails.AIRPORTNAME[0]
          };
          FlightSegmentListDetail.MarketingCarrier = {
            AirlineID: marketingCareerDetails.AIRLINEID[0],
            FlightNumber: marketingCareerDetails.FLIGHTNUMBER[0]
          };
          FlightSegmentListDetail.OperatingCarrier = {
            Name: operatingCareerDetails.NAME[0]
          };
          FlightSegmentListDetail.ClassOfService = {
            Code: classServiceDetails.CODE[0],
            MarketingName: classServiceDetails.MARKETINGNAME[0]
          };
          FlightSegmentListDetail.FlightDetail = {
            FlightSegmentType: flightDetails.FLIGHTSEGMENTTYPE[0]
          };
          pnrDetail.FlightSegmentList.push(FlightSegmentListDetail);
        });
      }
      if (this.pending) {
        pnrDetail.tab = 'PENDING';
        pendingPnrDetails.push(pnrDetail);
      } else if (this.actioned) {
        pnrDetail.tab = 'ACTIONED';
        actionedPnrDetails.push(pnrDetail);
      } else if (this.archive) {
        pnrDetail.tab = 'ARCHIVE';
        archivePnrDetails.push(pnrDetail);
      }
    });
    if (this.pending) {
      this.ocnMessageScreen.overAllPendingPnrDetails = pendingPnrDetails;
      this.ocnMessageScreen.pendingPnrDetails = pendingPnrDetails;
      this.ocnMessageScreen.sortPendingPnrDetails = [];
    }
    if (this.actioned) {
      this.ocnMessageScreen.overAllActionedPnrDetails = actionedPnrDetails;
      this.ocnMessageScreen.actionedPnrDetails = actionedPnrDetails;
      this.ocnMessageScreen.sortActionedPnrDetails = [];
    }
    if (this.archive) {
      this.ocnMessageScreen.overAllArchivePnrDetails = archivePnrDetails;
      this.ocnMessageScreen.archivePnrDetails = archivePnrDetails;
      this.ocnMessageScreen.sortArchivePnrDetails = [];
    }
    this.loadTAB(status, true);
    if (this.pending) {
      this.sandboxPageStateService.updateDistruptedPnrCount(distruptedPnrCount);
    }
  }
  //ARCHIVE PAGINATION FUNCTION
  renderArchivePnrPagination() {
    let pnrDetail = this.ocnMessageScreen.archivePnrDetails;
    this.ocnMessageScreen.sortArchivePnrDetails = [];
    let totalPnrDetailCount = pnrDetail.length;
    let activeLength = this.archiveOcnMessagePaginationSettings.activeLength;
    let activePaginationIndex = this.archiveOcnMessagePaginationSettings.activePageIndex;
    let buttonCount: any = totalPnrDetailCount / activeLength;
    if (buttonCount % 1 != 0) {
      buttonCount = parseInt(buttonCount);
      buttonCount = buttonCount + 1;
    }
    this.archiveOcnMessagePaginationSettings.maxPageIndex = buttonCount - 1;
    let buttonStart = activePaginationIndex - this.archiveOcnMessagePaginationSettings.beforeActiveMenuButtonCount;
    if (buttonStart < 0) {
      buttonStart = 0;
    }
    let buttonEnd = buttonStart + 1 + this.archiveOcnMessagePaginationSettings.afterActiveMenuButtonCount;
    if (buttonEnd >= buttonCount) {
      buttonEnd = buttonCount - 1;
      if (buttonEnd - (1 + this.archiveOcnMessagePaginationSettings.beforeActiveMenuButtonCount) > 0) {
        buttonStart = buttonEnd - (1 + this.archiveOcnMessagePaginationSettings.beforeActiveMenuButtonCount);
      }
    }
    this.archiveOcnMessagePaginationSettings.buttonList = [];
    let j = 0;
    for (let i = buttonStart; i <= buttonEnd; i++) {
      this.archiveOcnMessagePaginationSettings.buttonList.push({
        text: i + 1,
        value: i,
        isActive: activePaginationIndex === i ? 'Yes' : 'No',
        index: j
      });
      j++;
    }
    let startIndex = activePaginationIndex * activeLength;
    let endIndex = startIndex + activeLength;
    for (let i = startIndex; i < endIndex; i++) {
      if (typeof pnrDetail[i] !== 'undefined') {
        this.ocnMessageScreen.sortArchivePnrDetails.push(pnrDetail[i]);
      }
    }
  }
  updateArchivedOcnMessagePagination(activeIndex: any) {
    this.archiveOcnMessagePaginationSettings.activePageIndex = this.archiveOcnMessagePaginationSettings.buttonList[activeIndex].value;
    this.renderArchivePnrPagination();
  }
  updateArchivedPaginationLength() {
    this.archiveOcnMessagePaginationSettings.activePageIndex = 0;
    this.archiveOcnMessagePaginationSettings.start = 0;
    this.renderArchivePnrPagination();
  }
  triggerArchivedRender(type: 'minus' | 'plus') {
    let activePaginationIndex = this.archiveOcnMessagePaginationSettings.activePageIndex;
    let newIndex = activePaginationIndex;
    if (type === 'minus') {
      newIndex = activePaginationIndex - 1;
    } else {
      newIndex = activePaginationIndex + 1;
    }
    this.archiveOcnMessagePaginationSettings.activePageIndex = newIndex;
    this.renderArchivePnrPagination();
  }
  //end
  updateActionedOcnMessagePagination(activeIndex: any) {
    this.actionedOcnMessagePaginationSettings.activePageIndex = this.actionedOcnMessagePaginationSettings.buttonList[activeIndex].value;
    this.renderActionedPnrPagination();
  }
  updateActionedPaginationLength() {
    this.actionedOcnMessagePaginationSettings.activePageIndex = 0;
    this.actionedOcnMessagePaginationSettings.start = 0;
    this.renderActionedPnrPagination();
  }
  renderActionedPnrPagination() {
    let pnrDetail = this.ocnMessageScreen.actionedPnrDetails;
    this.ocnMessageScreen.sortActionedPnrDetails = [];
    let totalPnrDetailCount = pnrDetail.length;
    let activeLength = this.actionedOcnMessagePaginationSettings.activeLength;
    let activePaginationIndex = this.actionedOcnMessagePaginationSettings.activePageIndex;
    let buttonCount: any = totalPnrDetailCount / activeLength;
    if (buttonCount % 1 != 0) {
      buttonCount = parseInt(buttonCount);
      buttonCount = buttonCount + 1;
    }
    this.actionedOcnMessagePaginationSettings.maxPageIndex = buttonCount - 1;
    let buttonStart = activePaginationIndex - this.actionedOcnMessagePaginationSettings.beforeActiveMenuButtonCount;
    if (buttonStart < 0) {
      buttonStart = 0;
    }
    let buttonEnd = buttonStart + 1 + this.actionedOcnMessagePaginationSettings.afterActiveMenuButtonCount;
    if (buttonEnd >= buttonCount) {
      buttonEnd = buttonCount - 1;
      if (buttonEnd - (1 + this.actionedOcnMessagePaginationSettings.beforeActiveMenuButtonCount) > 0) {
        buttonStart = buttonEnd - (1 + this.actionedOcnMessagePaginationSettings.beforeActiveMenuButtonCount);
      }
    }
    this.actionedOcnMessagePaginationSettings.buttonList = [];
    let j = 0;
    for (let i = buttonStart; i <= buttonEnd; i++) {
      this.actionedOcnMessagePaginationSettings.buttonList.push({
        text: i + 1,
        value: i,
        isActive: activePaginationIndex === i ? 'Yes' : 'No',
        index: j
      });
      j++;
    }
    let startIndex = activePaginationIndex * activeLength;
    let endIndex = startIndex + activeLength;
    for (let i = startIndex; i < endIndex; i++) {
      if (typeof pnrDetail[i] !== 'undefined') {
        this.ocnMessageScreen.sortActionedPnrDetails.push(pnrDetail[i]);
      }
    }
  }
  updatePendingPaginationLength() {
    this.pendingOcnMessagePaginationSettings.activePageIndex = 0;
    this.pendingOcnMessagePaginationSettings.start = 0;
    this.renderPendingPnrPagination();
  }
  updatePendingOcnMessagePagination(activeIndex: any) {
    this.pendingOcnMessagePaginationSettings.activePageIndex = this.pendingOcnMessagePaginationSettings.buttonList[activeIndex].value;
    this.renderPendingPnrPagination();
  }
  triggerActionedRender(type: 'minus' | 'plus') {
    let activePaginationIndex = this.actionedOcnMessagePaginationSettings.activePageIndex;
    let newIndex = activePaginationIndex;
    if (type === 'minus') {
      newIndex = activePaginationIndex - 1;
    } else {
      newIndex = activePaginationIndex + 1;
    }
    this.actionedOcnMessagePaginationSettings.activePageIndex = newIndex;
    this.renderActionedPnrPagination();
  }
  triggerPendingRender(type: 'minus' | 'plus') {
    let activePaginationIndex = this.pendingOcnMessagePaginationSettings.activePageIndex;
    let newIndex = activePaginationIndex;
    if (type === 'minus') {
      newIndex = activePaginationIndex - 1;
    } else {
      newIndex = activePaginationIndex + 1;
    }
    this.pendingOcnMessagePaginationSettings.activePageIndex = newIndex;
    this.renderPendingPnrPagination();
  }
  renderPendingPnrPagination() {
    let pnrDetail = this.ocnMessageScreen.pendingPnrDetails;
    this.ocnMessageScreen.sortPendingPnrDetails = [];
    let totalPnrDetailCount = pnrDetail.length;
    let activeLength = this.pendingOcnMessagePaginationSettings.activeLength;
    let activePaginationIndex = this.pendingOcnMessagePaginationSettings.activePageIndex;
    let buttonCount: any = totalPnrDetailCount / activeLength;
    if (buttonCount % 1 != 0) {
      buttonCount = parseInt(buttonCount);
      buttonCount = buttonCount + 1;
    }
    this.pendingOcnMessagePaginationSettings.maxPageIndex = buttonCount - 1;
    let buttonStart = activePaginationIndex - this.pendingOcnMessagePaginationSettings.beforeActiveMenuButtonCount;
    if (buttonStart < 0) {
      buttonStart = 0;
    }
    let buttonEnd = buttonStart + 1 + this.pendingOcnMessagePaginationSettings.afterActiveMenuButtonCount;
    if (buttonEnd >= buttonCount) {
      buttonEnd = buttonCount - 1;
    }
    if (buttonEnd - (1 + this.pendingOcnMessagePaginationSettings.beforeActiveMenuButtonCount) >= 0) {
      buttonStart = buttonEnd - (1 + this.pendingOcnMessagePaginationSettings.beforeActiveMenuButtonCount);
    }
    this.pendingOcnMessagePaginationSettings.buttonList = [];
    let j = 0;
    for (let i = buttonStart; i <= buttonEnd; i++) {
      this.pendingOcnMessagePaginationSettings.buttonList.push({
        text: i + 1,
        value: i,
        isActive: activePaginationIndex === i ? 'Yes' : 'No',
        index: j
      });
      j++;
    }
    let startIndex = activePaginationIndex * activeLength;
    let endIndex = startIndex + activeLength;
    for (let i = startIndex; i < endIndex; i++) {
      if (typeof pnrDetail[i] !== 'undefined') {
        this.ocnMessageScreen.sortPendingPnrDetails.push(pnrDetail[i]);
      }
    }
  }
  loadTAB(type: 'PENDING' | 'ACTIONED' | 'ARCHIVE', renderPagination: any = null) {
    this.ocnMessageError = '';
    this.pending = false;
    this.actioned = false;
    this.archive = false;
    // this.resetForm();
    if (type === 'PENDING') {
      this.pending = true;
      // if (this.ocnMessageScreen.pendingPnrDetails.length === 0 && renderPagination === null) {
      //   this.getOcnMessages('PENDING');
      // } else {
      this.renderPendingPnrPagination();
      // }
    } else if (type === 'ACTIONED') {
      this.actioned = true;
      // if (this.ocnMessageScreen.actionedPnrDetails.length === 0 && renderPagination === null) {
      //   this.getOcnMessages('ACTIONED');
      // } else {
      this.renderActionedPnrPagination();
      // }
    } else if (type === 'ARCHIVE') {
      this.archive = true;
      // if (this.ocnMessageScreen.archivePnrDetails.length === 0 && renderPagination === null) {
      //   this.getOcnMessages('ARCHIVE');
      // } else {
      this.renderArchivePnrPagination();
      // }
    }
  }
  getSelectedPnrDetails(status: 'PENDING' | 'ARCHIVE', selectedindex: any) {
    let selectedPNR: any = '';
    let selectedPNRTimestamp: any = '';
    let selectedPNRStatus: any = '';
    if (status === 'PENDING') {
      selectedPNR = this.ocnMessageScreen.sortPendingPnrDetails[selectedindex].pnr;
      selectedPNRTimestamp = this.ocnMessageScreen.sortPendingPnrDetails[selectedindex].current_timestamp;
      selectedPNRStatus = this.ocnMessageScreen.sortPendingPnrDetails[selectedindex].status;
    } else if (status) {
      selectedPNR = this.ocnMessageScreen.sortArchivePnrDetails[selectedindex].pnr;
      selectedPNRTimestamp = this.ocnMessageScreen.sortArchivePnrDetails[selectedindex].current_timestamp;
      selectedPNRStatus = this.ocnMessageScreen.sortArchivePnrDetails[selectedindex].status;
    }
    if (selectedPNRStatus === 'PENDING') {
      let findOrderScreenData = this.sandboxPageStateService.getFindOrderScreenData();
      findOrderScreenData.pnr = selectedPNR;
      findOrderScreenData.current_timestamp = selectedPNRTimestamp;
      findOrderScreenData.haveOcnNotificationDetail = true;
      this.sandboxPageStateService.updateFindOrderScreen(findOrderScreenData);

      this.changeDateAndTime = this.sandboxPageStateService.getYourBookingScreenData();
      this.changeDateAndTime.haveOcnNotificationDetail = true;
      this.changeDateAndTime.pnrNumber = selectedPNR;
      this.changeDateAndTime.current_timestamp = selectedPNRTimestamp;
      this.sandboxPageStateService.updateYourBookingScreenData(this.changeDateAndTime);

      let patchSandboxSourceData: any = '';
      patchSandboxSourceData = { mainMenu: 'Yes', sandboxScreen: 'your-booking-screen' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }
  resetForm() {
    this.searchForm.patchValue({
      pnr: '',
      fromDate: '',
      toDate: ''
    });
    this.minToDate = '';
    this.maxToDate = '';
  }
  resetFilter() {
    this.resetForm();
    // this.ocnMessageScreen.pendingPnrDetails = this.ocnMessageScreen.overAllPendingPnrDetails;
    // this.ocnMessageScreen.actionedPnrDetails = this.ocnMessageScreen.overAllActionedPnrDetails;
    // this.ocnMessageScreen.archivePnrDetails = this.ocnMessageScreen.overAllArchivePnrDetails;
    this.pendingOcnMessagePaginationSettings.activePageIndex = 0;
    this.pendingOcnMessagePaginationSettings.activeLength = 10;
    this.actionedOcnMessagePaginationSettings.activePageIndex = 0;
    this.actionedOcnMessagePaginationSettings.activeLength = 10;
    this.archiveOcnMessagePaginationSettings.activePageIndex = 0;
    this.archiveOcnMessagePaginationSettings.activeLength = 10;
  }

  searchPNR() {
    let pnr = this.search_form_inp_group_val('pnr').trim();
    let fromDate = this.search_form_inp_group_val('fromDate').trim();
    let toDate = this.search_form_inp_group_val('toDate').trim();
    let pnrDetail: any = [];
    if (this.pending) {
      this.getOcnMessages('PENDING');
      this.pendingOcnMessagePaginationSettings.activePageIndex = 0;
      this.pendingOcnMessagePaginationSettings.activeLength = 10;
      this.ocnMessageScreen.sortPendingPnrDetails = [];
      pnrDetail = this.ocnMessageScreen.overAllPendingPnrDetails;
    } else if (this.actioned) {
      this.getOcnMessages('ACTIONED');
      this.actionedOcnMessagePaginationSettings.activePageIndex = 0;
      this.actionedOcnMessagePaginationSettings.activeLength = 10;
      this.ocnMessageScreen.sortActionedPnrDetails = [];
      pnrDetail = this.ocnMessageScreen.overAllActionedPnrDetails;
    } else if (this.archive) {
      this.getOcnMessages('ARCHIVE');
      this.archiveOcnMessagePaginationSettings.activePageIndex = 0;
      this.archiveOcnMessagePaginationSettings.activeLength = 10;
      this.ocnMessageScreen.sortArchivePnrDetails = [];
      pnrDetail = this.ocnMessageScreen.overAllArchivePnrDetails;
    }
    // else if (fromDate != '' && toDate != '') {
    //   fromDate = new Date(fromDate);
    //   toDate = new Date(toDate);
    //   let filterPnrDetails: any = [];
    //   pnrDetail.forEach((result: any) => {
    //     let depatureDate = new Date(result.UNDate);
    //     if (depatureDate >= fromDate && depatureDate <= toDate) {
    //       filterPnrDetails.push(result);
    //     }
    //   });
    //   if (this.pending) {
    //     this.ocnMessageScreen.pendingPnrDetails = filterPnrDetails;
    //     this.renderPendingPnrPagination();
    //   } else if (this.actioned) {
    //     this.ocnMessageScreen.actionedPnrDetails = filterPnrDetails;
    //     this.renderActionedPnrPagination();
    //   } else {
    //     this.ocnMessageScreen.archivePnrDetails = filterPnrDetails;
    //     this.renderArchivePnrPagination();
    //   }
    // }
    else {
      if (this.pending) {
        this.loadTAB('PENDING');
      } else if (this.actioned) {
        this.loadTAB('ACTIONED');
      } else {
        this.loadTAB('ARCHIVE');
      }
    }
  }

  findPNR() {
    let pnr = this.search_form_inp_group_val('pnr').trim();
    let pnrDetail: any = [];
    if (this.pending) {
      this.pendingOcnMessagePaginationSettings.activePageIndex = 0;
      this.pendingOcnMessagePaginationSettings.activeLength = 10;
      this.ocnMessageScreen.pendingPnrDetails = [];
      pnrDetail = this.ocnMessageScreen.overAllPendingPnrDetails;
    } else if (this.actioned) {
      this.actionedOcnMessagePaginationSettings.activePageIndex = 0;
      this.actionedOcnMessagePaginationSettings.activeLength = 10;
      this.ocnMessageScreen.actionedPnrDetails = [];
      pnrDetail = this.ocnMessageScreen.overAllActionedPnrDetails;
    } else {
      this.archiveOcnMessagePaginationSettings.activePageIndex = 0;
      this.archiveOcnMessagePaginationSettings.activeLength = 10;
      this.ocnMessageScreen.archivePnrDetails = [];
      pnrDetail = this.ocnMessageScreen.overAllArchivePnrDetails;
    }
    if (pnr != '') {
      let filterPnrDetails = [];
      filterPnrDetails.push(...pnrDetail.find((result: any) => result.pnr.includes(pnr)));
      if (typeof filterPnrDetails !== 'undefined') {
        if (this.pending) {
          this.ocnMessageScreen.pendingPnrDetails.push(...filterPnrDetails);
        } else if (this.actioned) {
          this.ocnMessageScreen.actionedPnrDetails.push(...filterPnrDetails);
        } else {
          this.ocnMessageScreen.archivePnrDetails.push(...filterPnrDetails);
        }
      }
    } else {
      if (this.pending) {
        this.ocnMessageScreen.pendingPnrDetails.push(...pnrDetail);
      } else if (this.actioned) {
        this.ocnMessageScreen.actionedPnrDetails.push(...pnrDetail);
      } else {
        this.ocnMessageScreen.archivePnrDetails.push(...pnrDetail);
      }
    }
    if (this.pending) {
      this.loadTAB('PENDING');
    } else if (this.actioned) {
      this.loadTAB('ACTIONED');
    } else {
      this.loadTAB('ARCHIVE');
    }
  }

  viewXML(i: any) {
    let selectedXML: any;

    if (this.pending) {
      selectedXML = new Blob([this.ocnMessageScreen.sortPendingPnrDetails[i].xml], { type: 'application/xml' });
    }
    if (this.actioned) {
      selectedXML = new Blob([this.ocnMessageScreen.sortActionedPnrDetails[i].xml], { type: 'application/xml' });
    }
    if (this.archive) {
      selectedXML = new Blob([this.ocnMessageScreen.sortArchivePnrDetails[i].xml], { type: 'application/xml' });
    }

    var fileURL = URL.createObjectURL(selectedXML);
    window.open(fileURL);
    var anchorElement = document.createElement('a');
    anchorElement.href = fileURL;
    anchorElement.target = '_blank';
    document.body.appendChild(anchorElement);
  }

  downloadXML(i: any) {
    let selectedXML = '';

    if (this.pending) {
      selectedXML = this.ocnMessageScreen.sortPendingPnrDetails[i].xml;
    }

    if (this.actioned) {
      selectedXML = this.ocnMessageScreen.sortActionedPnrDetails[i].xml;
    }
    if (this.archive) {
      selectedXML = this.ocnMessageScreen.sortArchivePnrDetails[i].xml;
    }

    try {
      let currentDate: string = new Date().toString();
      let formattedDate = this.datePipe.transform(currentDate, 'medium');
      var blob = new Blob([xmlFormat(selectedXML, { collapseContent: true })], { type: 'application/xml' });
      FileSaver.saveAs(blob, 'OrderChangeNotiffMessage' + ` ${formattedDate}.xml`);
    } catch (error: any) {
      var blob = new Blob([selectedXML], { type: 'application/json' });
      FileSaver.saveAs(blob + '.json');
    }
  }

  checkUncheckAll() {
    for (var i = 0; i < this.ocnMessageScreen.sortPendingPnrDetails.length; i++) {
      this.ocnMessageScreen.sortPendingPnrDetails[i].isSelected = this.masterSelected;
    }
    this.slectPNRDetail();
  }

  isAllSelected() {
    this.masterSelected = this.ocnMessageScreen.sortPendingPnrDetails.every(function (item: any) {
      return item.isSelected == true;
    });
    this.slectPNRDetail();
  }

  slectPNRDetail() {
    this.reqBody = [];

    for (var i = 0; i < this.ocnMessageScreen.sortPendingPnrDetails.length; i++) {
      if (this.ocnMessageScreen.sortPendingPnrDetails[i].isSelected) {
        let pnrDetails = {} as RequestBody;

        pnrDetails.pnr = this.ocnMessageScreen.sortPendingPnrDetails[i].pnr;
        pnrDetails.currentTimestamp = this.ocnMessageScreen.sortPendingPnrDetails[i].current_timestamp;
        pnrDetails.changedBy = this.loggeduserMailID;
        pnrDetails.status = 'ARCHIVED';
        pnrDetails.userAction = 'ARCHIVED';

        this.reqBody.push(pnrDetails);
      }
    }
  }

  movetoArchived() {
    this.sandboxPageStateService.updateDisruptedOrderRequstBody(this.reqBody);
  }
}
